import { Component, OnInit,ViewChild, ElementRef, ViewChildren, QueryList } from "@angular/core";
import { ApiService } from "src/app/service/api.service";
import { CoreService } from "src/app/service/core.service";
import * as XLSX from "xlsx";
import { NgSelectComponent } from '@ng-select/ng-select';
import { CurrencyPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "src/app/service/excel.service";

@Component({
  selector: "app-price-list",
  templateUrl: "./price-list.component.html",
  styleUrls: ["./price-list.component.css"],
})
export class PriceListComponent implements OnInit {


  @ViewChild('selectproductId', { static: false }) selectproductId: NgSelectComponent;
  @ViewChildren("selPrdCode") selPrdCode: QueryList<ElementRef>;


  fileName = "price_list.xlsx";
  stkprd_all: any = [];
  stkprdsel: any;
  productunit: any;
  product: any;
  stkprdunit: any;
  no_transfr: string='';
  no_transfr1: string='';
  no_transfr2: string='';
   prdunit: any;
  rate: any;
  selectPrd: any;
  unit_name: any;
  prd: any;
  catagories: any;
  productbarcode: any;
  prd_barcode: null;
  trnfr_to_table = [];
  Notes: string;
  slno = 0;
  tax: any;
  tax_includ_rate: any;
  branch_display_name: any;
  branch_display_code: any;
  branch_address:any;
  note: any;
  country_dec: number=2;
  prdctloading: boolean;
  catloading:boolean;
  cat_id: any;
  prod_alias: any;
  cur_lang: string;
  g_settings: any;
  generalSearch_type: any;
  mfs: string[];
  subcatagories:any;
  sub_cat_id: any;
  manufacture_id: any;

  constructor(
    private apiService: ApiService,
    private coreService: CoreService,
    private excelService: ExcelService,
    private currencyPipe: CurrencyPipe,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.getGeneralSetting();
    this.cur_lang = sessionStorage.getItem("baseLang");
this.aliasChecked()
  this.apiService.cur_lang.subscribe(value =>{
      this.cur_lang = value;
      this.aliasChecked()
    })

    this.branch_display_name = this.coreService.getUserData("branch_disp_name");
    this.branch_display_code = this.coreService.getUserData("branch_code");
    this.branch_address = this.coreService.getUserData('branch_address');

    this.country_dec=this.coreService.setDecimalLength();
    this.searchCat('');
    // this.catagories.push({ cat_id: 0, cat_name: 'All' });
    setTimeout(() => {
      this.selPrdCode.last.nativeElement.focus();
    }, 500);
   
  }


  aliasChecked(){
    if(this.cur_lang !=undefined && this.cur_lang !=null && this.cur_lang !='English' ){
      this.prod_alias = 'alias_true';
     
    }else{
      this.prod_alias =null;
      
    }
  }

  searchCat(search: string) {
    
    const searchval = new FormData();
    searchval.append('cat_name', search);
    this.apiService.getCatbyName(searchval).subscribe((res) => {
      this.catagories = res['data'];
      this.catagories.push({ cat_id: 0, cat_name: 'All' });
    });

  }

  searchStkPrd(search: string) {
    $("#br_err").text("");
    let searchval = new FormData();
    searchval.append("keyword", search);
    searchval.append("stk_stat", "1");
    if(this.prod_alias){
      searchval.append('alias_search', '1');
    }
    this.apiService.getStockbyItem(searchval).subscribe((res) => {
      this.stkprd_all = res["data"];
    });
  }

  selectStockcategorywise(data){
    if (data ||data ==0) {
    $("#br_err").text("");
    this.catloading=true;
      this.prdctloading=true;
      let searchval = new FormData();
      searchval.append("catId", data); 
      this.apiService.getpricelist(searchval).subscribe((res) => {
        if(res.data){
          this.stkprd_all = res.data;
           console.log(this.stkprd_all);
          // this.note = res.value.Notes;
          this.stkprd_all.forEach((element, index) => {
            this.trnfr_to_table.push({
              sl_no: index+1,
              Product:element.prd_name,
              alias:element.prd_alias,
              Unit:element.unit_name,
              Rate:element.baserate,
              barcode:element.prd_barcode,
              tax:element.bs_tax,
              tax_icld_rate:element.bs_tax_includ_rate,

      });
      this.cat_id=null;
      this.sub_cat_id=null;
      this.manufacture_id=null;
    });
    this.no_transfr='';
    console.log(this.trnfr_to_table);
    this.prdctloading=false;
    this.catloading=false;
    this.productbarcode = null;
  }else{
    this.no_transfr='Unfortunately, there are no products in this category';
    this.prdctloading=false;
    this.catloading=false;
    this.productbarcode = null;
  }
    });



  }
    
  }
  
  selectSubCats(data){
    if (data ||data ==0) {
    $("#br_err").text("");
    this.catloading=true;
      this.prdctloading=true;
      let searchval = new FormData();
      searchval.append("subcatId", data); 
      this.apiService.getpricelist(searchval).subscribe((res) => {
        if(res.data){
          this.stkprd_all = res.data;
           console.log(this.stkprd_all);
          // this.note = res.value.Notes;
          this.stkprd_all.forEach((element, index) => {
            this.trnfr_to_table.push({
              sl_no: index+1,
              Product:element.prd_name,
              alias:element.prd_alias,
              Unit:element.unit_name,
              Rate:element.baserate,
              barcode:element.prd_barcode,
              tax:element.bs_tax,
              tax_icld_rate:element.bs_tax_includ_rate,

      });
      this.cat_id=null;
      this.sub_cat_id='';
      this.manufacture_id=null;
    });
    this.no_transfr1='';
    console.log(this.trnfr_to_table);
    this.prdctloading=false;
    this.catloading=false;
    this.productbarcode = null;
  }else{
    this.no_transfr1='Unfortunately, there are no products in this subcategory';
    this.prdctloading=false;
    this.catloading=false;
    this.productbarcode = null;
  }
    });



  }
    
  }

  selectManFact(data){
    if (data ||data ==0) {
    $("#br_err").text("");
    this.catloading=true;
      this.prdctloading=true;
      let searchval = new FormData();
      searchval.append("manfactId", data); 
      this.apiService.getpricelist(searchval).subscribe((res) => {
        if(res.data){
          this.stkprd_all = res.data;
           console.log(this.stkprd_all);
          // this.note = res.value.Notes;
          this.stkprd_all.forEach((element, index) => {
            this.trnfr_to_table.push({
              sl_no: index+1,
              Product:element.prd_name,
              alias:element.prd_alias,
              Unit:element.unit_name,
              Rate:element.baserate,
              barcode:element.prd_barcode,
              tax:element.bs_tax,
              tax_icld_rate:element.bs_tax_includ_rate,

      });
      this.cat_id=null;
      this.sub_cat_id=null;
      this.manufacture_id=null;
    });
    this.no_transfr2='';
    console.log(this.trnfr_to_table);
    this.prdctloading=false;
    this.catloading=false;
    this.productbarcode = null;
  }else{
    this.no_transfr2='Unfortunately, there are no products in this manufacture';
    this.prdctloading=false;
    this.catloading=false;
    this.productbarcode = null;
  }
    });



  }
    
  }
  

  selectStockPrd(data) {
    if (data) {
      this.cat_id=null
      this.sub_cat_id=null;
      this.manufacture_id=null;
      this.no_transfr='';
      $("#br_err").text("");
      this.prdctloading=true;
      let searchval = new FormData();
      searchval.append("productId", data);
      this.apiService.getpricelist(searchval).subscribe((res) => {
        this.prdctloading=false;
        this.productbarcode = res.data[0].prd_barcode;
        this.productunit = res.data[0]["units"];
        this.prdunit = res.data[0].select_unit_id;
        this.rate = res.data[0].baserate;
        this.unit_name = res.data[0].unit_name;
        this.stkprd_all = res.data;
        this.tax = res.data[0].bs_tax;
        this.tax_includ_rate = res.data[0].bs_tax_includ_rat
        this.selectproductId.focus()
       
      });
    }
  }

  searchStkPrdBarcode(barcode) {
    this.cat_id=null
    this.stkprd_all = null;
    this.prdunit = null;
    this.rate = null;
    this.product = null;
    this.productunit = null;
    this.unit_name = null;
    this.tax_includ_rate = null;
    this.tax = null;
    this.tax_includ_rate = null;
    if (barcode) {
      this.prdctloading=true;
      $("#br_err").text("");
      this.no_transfr='';
      let searchval = new FormData();
      searchval.append("productbarcode", barcode);
      this.apiService.getpricelist(searchval).subscribe((res) => {
        if (res.data) {
          this.stkprd_all = res.data;
          this.product = res.data[0].prd_id;
          this.productunit = res.data[0]["units"];
          this.prdunit = res.data[0].select_unit_id;
          this.unit_name = res.data[0].unit_name;
          this.rate = res.data[0].baserate;
          this.tax = res.data[0].bs_tax;
          this.tax_includ_rate = res.data[0].bs_tax_includ_rate;
            setTimeout(() => {
              
              $("#listbtn").click();
        }, 500);
        
        } else {
          console.log(" No product found");
          $("#br_err").text("No product found");
          this.stkprd_all = [];
        }
        this.prdctloading=false;
      });
     
    }
    
  }
    //form search
    searchForm(search: string) {
      let searchval = new FormData();
      searchval.append("cat_name", search);
      this.apiService.getSubCatbyName(searchval).subscribe((res) => {
        this.subcatagories = res['data'];
      });
  
    }
    //form search  manufacture
    searchManf(search: string) {
      let searchval = new FormData();
      searchval.append("manftr_comp_name", search);
      this.apiService.getManfbyName(searchval).subscribe((res) => {
        this.mfs = res['data'];
      });
    }

  unitSelect(prdunitid) {
    if (prdunitid) {
      this.rate = this.productunit.find((x) => x.select_unit_id === prdunitid).rate1;
      this.tax = this.productunit.find((x) => x.select_unit_id === prdunitid).tax;
      this.tax_includ_rate = this.productunit.find((x) => x.select_unit_id === prdunitid).tax_includ_rate;
      this.unit_name = this.productunit.find((x) => x.select_unit_id === prdunitid).unit_name;
     
      $('#listbtn').focus();
    }
  }

  reFreshAll() {
    this.stkprd_all = null;
    this.prdunit = null;
    this.rate = null;
    this.product = null;
    this.productunit = null;
    this.productbarcode = null;
    this.unit_name = null;
    this.tax_includ_rate = null;
    this.tax = null;
    this.tax_includ_rate = null;
  }

  addToList(res: { value: any }) {
 

    if (res.value.product) {
      // this.note = res.value.Notes;
  
      this.slno = this.slno + 1;
      this.trnfr_to_table.push({
        sl_no: this.slno,
        Product: this.stkprd_all[0].prd_name,
        alias: this.stkprd_all[0].prd_alias,
        barcode: this.stkprd_all[0].prd_barcode,
        Unit: res.value.unit_name,
        Rate: res.value.rate,
        tax: res.value.tax,
        tax_icld_rate: res.value.tax_includ_rate,
      });

      this.reFreshAll();
      // setTimeout(() => {
        this.selPrdCode.last.nativeElement.focus();
      // }, 500);
    }
  }

  deleteFromList(data: any) {
   
    var type = data.sl_no,
      i;

    for (i = this.trnfr_to_table.length - 1; i >= 0; --i) {
      if (this.trnfr_to_table[i].sl_no == type) {
        this.trnfr_to_table.splice(i, 1);
      }
    }
  }


  clearall()  {
    if (this.trnfr_to_table.length > 0) {
      if (confirm('Are you sure to clear all ?')) {
        this.trnfr_to_table.splice(0, this.trnfr_to_table.length);
      }
     
    }
  }

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById("export-group");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
    // this.exportLoader = false;
  }

  // pdf download
  generatePdf() {
  
    const heads = [
      this.translate.instant('Table.sl_no'),
      this.translate.instant('HOME.PRODUCTS'),
      this.translate.instant('Repproduct.product_alias'),
      this.translate.instant('Table.product_barcode'),
      this.translate.instant('HOME.UNIT'),
      this.translate.instant('Common.rate'),
      this.translate.instant('Common.tax'),
      this.translate.instant('Purchase.Tax_Include_Rate')
    ];

      const lblXPos = 10;
      const headerHeight = 15;
      const valueXPos = 55;
      const data = [];

      this.trnfr_to_table.forEach((item,i)=>{
        data.push([
          i+1,
          item.Product,
          item.alias,
          item.barcode,
          item.Unit,
          item.Rate.toFixed(this.country_dec),
          item.tax.toFixed(this.country_dec),
          item.tax_icld_rate.toFixed(this.country_dec),
    
        ])
      })
  
      let doc = this.excelService.getPdfObj();

      var addressLines = this.branch_address.split('\r\n');
      var addressText = addressLines.join(', ');

      doc.setFont('Amiri');
      doc.setFontSize(12);
      doc.text(this.branch_display_name +' ' + '(' + this.branch_display_code + ')', 70, headerHeight - 2);

      doc.setFont('Amiri');
      doc.setFontSize(9);
      doc.text(addressText, 71, headerHeight + 2);

      doc.setFontSize(10);
      doc.text(`${this.translate.instant('HOME.REPORT')}`, lblXPos, headerHeight + 10);
      doc.setFontSize(10);
      doc.text(':  ' + 'PRICE LIST',  valueXPos, headerHeight + 10);

      doc.setFontSize(10);
      doc.text(`${this.translate.instant('Table.totl_item')}`, lblXPos, headerHeight + 15);
      doc.setFontSize(10);
      doc.text(':  ' + this.trnfr_to_table.length,  valueXPos, headerHeight + 15);
      
      doc = this.excelService.addTableToPdf(doc, headerHeight + 20, lblXPos, heads, data, null);
  
     
      doc.save(`Price List.pdf`);


    
  }

  getGeneralSetting() {

    this.apiService.getGeneralSetting().subscribe((res) => {
  
      // console.log(res['data']);
      this.g_settings = res['data'];
      this.generalSearch_type = this.g_settings.g_s_search_type;
      console.log(this.generalSearch_type);
      
    });
  
  }

}
